export class WorkspaceNotFound extends Error {
  name = "WorkspaceNotFound";
  message = "Workspace not found. Please refresh the page.";
}
